import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
//---- Automatically generated, don't update this part ----

/**
 * Represents a spirometer associated to a patient by its serial number
 */
export default class SpirometerAssociatedJournalEvent extends JournalEvent {
  static override type = "spirometer-associated-journal-event";

  @attr("string") declare serialNumber: string;

  static override validations(intl: IntlService) {
    return {
      serialNumber: validatePresence({
        presence: true,
        description: intl.t(
          "validations.spirometer-associated-journal-event.serial-number"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.spirometer-associated-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "spirometerAssociatedJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "spirometer-associated-journal-event": SpirometerAssociatedJournalEvent;
  }
}
